/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_DocumentInputs */

const en_document_document = /** @type {(inputs: Document_DocumentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`document`)
};

/**
* | output |
* | --- |
* | "document" |
*
* @param {Document_DocumentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const document_document = /** @type {((inputs?: Document_DocumentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_DocumentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_document_document(inputs)
});